// 公司：首创环保 v1_SH600008
// 模板：侧边栏PC（slide）
// 模块：公司公告（announcement）

import Overview from './overview.vue';
import MobFull from '@rebuild/materials/shared/announcement/mobile/FullIndex.vue';

export const componentMap = {
	overview: Overview,
	'mob-full': MobFull,
};
